// src/data.js

const data = [
  {
    id: 1,
    name: "An Archdemon's Dilemma: How to Love Your Elf Bride",
    link: "/An Archdemons Dilemma: How to Love Your Elf Bride",
  },
  {
    id: 2,
    name: "solo leveling",
    link: "/solo leveling",
  },

  {
    id: 3,
    name: "",
    link: "/",
  },

  {
    id: 4,
    name: "",
    link: "/",
  },

  {
    id: 5,
    name: "",
    link: "/",
  },

  {
    id: 6,
    name: "",
    link: "/",
  },

  {
    id: 7,
    name: "",
    link: "/",
  },

  {
    id: 8,
    name: "",
    link: "/",
  },

  {
    id: 9,
    name: "",
    link: "/",
  },

  {
    id: 10,
    name: "",
    link: "/",
  },

  {
    id: 11,
    name: "",
    link: "/",
  },

  {
    id: 12,
    name: "",
    link: "/",
  },

  {
    id: 13,
    name: "",
    link: "/",
  },

  {
    id: 14,
    name: "",
    link: "/",
  },

  {
    id: 15,
    name: "",
    link: "/",
  },

  {
    id: 16,
    name: "",
    link: "/",
  },

  {
    id: 17,
    name: "",
    link: "/",
  },

  {
    id: 18,
    name: "",
    link: "/",
  },

  {
    id: 19,
    name: "",
    link: "/",
  },

  {
    id: 20,
    name: "",
    link: "/",
  },

  {
    id: 21,
    name: "",
    link: "/",
  },

  {
    id: 22,
    name: "",
    link: "/",
  },

  {
    id: 23,
    name: "",
    link: "/",
  },

  {
    id: 24,
    name: "",
    link: "/",
  },

  {
    id: 25,
    name: "",
    link: "/",
  },

  {
    id: 26,
    name: "",
    link: "/",
  },

  {
    id: 27,
    name: "",
    link: "/",
  },

  {
    id: 27,
    name: "",
    link: "/",
  },

  {
    id: 28,
    name: "",
    link: "/",
  },

  {
    id: 29,
    name: "",
    link: "/",
  },

  {
    id: 30,
    name: "",
    link: "/",
  },

  {
    id: 31,
    name: "",
    link: "/",
  },

  {
    id: 32,
    name: "",
    link: "/",
  },

  {
    id: 34,
    name: "",
    link: "/",
  },

  {
    id: 35,
    name: "",
    link: "/",
  },

  {
    id: 36,
    name: "",
    link: "/",
  },

  {
    id: 37,
    name: "",
    link: "/",
  },

  {
    id: 38,
    name: "",
    link: "/",
  },

  {
    id: 39,
    name: "",
    link: "/",
  },

  {
    id: 40,
    name: "",
    link: "/",
  },

  {
    id: 41,
    name: "",
    link: "/",
  },

  // Add more items as needed
];

export default data;
